module.exports = __webpack_public_path__ + "static/media/mobile-sticky.12dc3422.png";